const chars = "abcdefghij";

let _uid = 0;

export const shortID = () => {
  // ensures uid consists of 5 chars
  // e.g 1 => 00001, 13 => 00013, 123 => 00123 ...
  const _padded = (_uid++ + "").padStart(5, "0");
  // convert numbers to alphabet
  // e.g 000 => aaa, 001 => aab etc.
  const asAlphabet = _padded
    .split("")
    .map((index) => chars[parseInt(index, 10)]);
  // prefix with `tjr-uid-`
  return "asp-uid-" + asAlphabet.join("");
};
